var _g, _path, _ellipse, _ellipse2, _g2, _g3, _path2, _ellipse3, _circle, _path3, _ellipse4, _circle2, _path4, _path5, _path6, _g4, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBadPack5 = function SvgBadPack5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "auto",
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bad-pack5_svg__a)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bad-pack5_svg__b)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.826,
    cy: 195.666,
    rx: 69.139,
    ry: 24.259,
    fill: "#FEAE52"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.01 134.398c0 48.159-41.739 87.334-93.398 87.334-51.66 0-93.399-39.175-93.399-87.334 0-48.159 41.739-87.334 93.399-87.334 51.659 0 93.398 39.175 93.398 87.334Z",
    fill: "#FED052",
    stroke: "url(#bad-pack5_svg__c)",
    strokeWidth: 2.426
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.612,
    cy: 134.398,
    rx: 94.611,
    ry: 88.547,
    fill: "url(#bad-pack5_svg__d)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.396,
    cy: 77.389,
    rx: 64.287,
    ry: 36.389,
    fill: "url(#bad-pack5_svg__e)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.34,
    filter: "url(#bad-pack5_svg__f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.453,
    cy: 144.103,
    rx: 32.75,
    ry: 18.195,
    fill: "url(#bad-pack5_svg__g)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.34,
    filter: "url(#bad-pack5_svg__h)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.345,
    cy: 144.103,
    rx: 32.75,
    ry: 18.195,
    fill: "url(#bad-pack5_svg__i)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.756 110.79c0 18.109-13.583 32.707-30.239 32.707-16.657 0-30.239-14.598-30.239-32.707s13.582-32.707 30.239-32.707c16.656 0 30.239 14.598 30.239 32.707Z",
    fill: "url(#bad-pack5_svg__j)",
    stroke: "url(#bad-pack5_svg__k)",
    strokeWidth: 1.234
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.39,
    cy: 116.961,
    rx: 13.577,
    ry: 14.811,
    fill: "url(#bad-pack5_svg__l)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 103.75,
    cy: 107.087,
    r: 7.405,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.431 115.727c0 13.171 9.878 23.787 21.992 23.787s21.992-10.616 21.992-23.787c0-13.17-9.878-23.787-21.992-23.787s-21.992 10.617-21.992 23.787Z",
    fill: "url(#bad-pack5_svg__m)",
    stroke: "url(#bad-pack5_svg__n)",
    strokeWidth: 0.898
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.874,
    cy: 10.771,
    rx: 9.874,
    ry: 10.771,
    transform: "matrix(-1 0 0 1 164.116 109.444)",
    fill: "url(#bad-pack5_svg__o)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.386,
    cy: 5.386,
    r: 5.386,
    transform: "matrix(-1 0 0 1 152.558 108.322)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.769 164.843c-17.933 6.404-19.373-10.028-30.708-11.599a2.18 2.18 0 0 0-.655.009c-17.936 2.984-30.607 40.05-12.609 41.335 18.106 1.294 32.332-24.572 54.318-24.572 21.986 0 9.053 14.226 29.746 15.519 20.693 1.294 9.053-32.332-9.053-32.332s-23.797 9.053-31.039 11.64Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.769 164.843c-17.933 6.404-19.373-10.028-30.708-11.599a2.18 2.18 0 0 0-.655.009c-17.936 2.984-30.607 40.05-12.609 41.335 18.106 1.294 32.332-24.572 54.318-24.572 21.986 0 9.053 14.226 29.746 15.519 20.693 1.294 9.053-32.332-9.053-32.332s-23.797 9.053-31.039 11.64Z",
    fill: "url(#bad-pack5_svg__p)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "bad-pack5_svg__q",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 153,
    width: 104,
    height: 42
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M132.769 164.843c-17.933 6.404-19.373-10.028-30.708-11.599a2.18 2.18 0 0 0-.655.009c-17.936 2.984-30.607 40.05-12.609 41.335 18.106 1.294 32.332-24.572 54.318-24.572 21.986 0 9.053 14.226 29.746 15.519 20.693 1.294 9.053-32.332-9.053-32.332s-23.797 9.053-31.039 11.64Z",
    fill: "#D9D9D9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bad-pack5_svg__q)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.605 168.722c-7.33 0-8.29-10.346-7.854-15.519H183.54c0 5.173-1.832 15.519-9.162 15.519-6.497 0-8.675-8.127-9.086-13.577-.011 5.45-1.815 13.577-9.239 13.577-6.477 0-8.155-6.184-8.18-11.38-.789 5.196-3.17 11.38-8.837 11.38-5.551 0-7.95-5.935-8.786-11.062.028 5.127-1.369 11.062-6.921 11.062-7.33 0-9.163-10.346-9.163-15.519 0 5.173-1.57 15.519-7.853 15.519-5.458 0-8.018-7.806-8.883-13.248.445 5.442-.457 13.248-6.824 13.248Z",
    fill: "#fff"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.769 164.843c-17.933 6.404-19.373-10.028-30.709-11.599a2.18 2.18 0 0 0-.655.009c-17.935 2.984-30.606 40.05-12.608 41.335 18.106 1.294 32.332-24.572 54.318-24.572 21.986 0 9.053 14.226 29.746 15.519 20.692 1.294 9.053-32.332-9.053-32.332s-23.797 9.053-31.039 11.64Z",
    stroke: "url(#bad-pack5_svg__r)",
    strokeWidth: 1.293,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bad-pack5_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 36.389 -64.2872 0 131.396 77.389)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#FCF2BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF2BD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bad-pack5_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.21296 14.55565 -26.20009 2.18332 80.453 144.103)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0B0A",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0B0A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bad-pack5_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.21296 14.55565 -26.20009 2.18332 182.345 144.103)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0B0A",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0B0A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bad-pack5_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 33.3243 -30.8558 0 102.517 110.79)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bad-pack5_svg__l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 14.8108 -13.5766 0 112.39 116.961)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#552313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bad-pack5_svg__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 24.2358 -22.4406 0 161.423 115.727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bad-pack5_svg__o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 10.7715 -9.87386 0 9.874 10.771)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#552313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bad-pack5_svg__p",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 20.7161 -51.8939 0 131.97 173.919)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#552313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bad-pack5_svg__c",
    x1: 38,
    y1: 141.676,
    x2: 227.223,
    y2: 140.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4D39D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#FDCA4D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4D39D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bad-pack5_svg__d",
    x1: 132.612,
    y1: 187.768,
    x2: 132.612,
    y2: 222.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2BD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD58F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bad-pack5_svg__k",
    x1: 102.517,
    y1: 77.466,
    x2: 102.517,
    y2: 144.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC03F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFE684"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bad-pack5_svg__n",
    x1: 161.423,
    y1: 91.492,
    x2: 161.423,
    y2: 139.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC03F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFE684"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bad-pack5_svg__r",
    x1: 131.97,
    y1: 153.203,
    x2: 131.97,
    y2: 194.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE5A0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bad-pack5_svg__b",
    x: 11.073,
    y: 117.794,
    width: 245.504,
    height: 155.745,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.807,
    result: "effect1_foregroundBlur_747_99"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bad-pack5_svg__f",
    x: 32.419,
    y: 110.625,
    width: 96.067,
    height: 66.956,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.642,
    result: "effect1_foregroundBlur_747_99"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bad-pack5_svg__h",
    x: 134.312,
    y: 110.625,
    width: 96.067,
    height: 66.956,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.642,
    result: "effect1_foregroundBlur_747_99"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bad-pack5_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h270v270H0z"
  })))));
};
export default SvgBadPack5;